import React from 'react'
import {
  IconButton,
  MenuItem,
  Typography,
  Stack,
  Tooltip,
} from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import { CoreIconButton } from 'src/components/core'
import { deleteCollection } from 'src/reducers/collection/action'
import MenuPopover from 'src/components/MenuPopover'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import useTrackerFunction from 'src/hooks/useTrackerFunction'

const CollectionToolBar = props => {
  // `renderTrigger` replaces the default "View all" + menu button; it gets
  // `{ openMenu }`.
  const { collection, refresh, classes, renderTrigger } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const [toolBarOpen, setToolBarOpen] = React.useState(null)

  // Tracking functions
  const trackViewAll = useTrackerFunction('clicked_view_all_courses')
  const trackMenuOpen = useTrackerFunction('opened_collection_menu')
  const trackDetailClick = useTrackerFunction('clicked_collection_detail')
  const trackDeleteClick = useTrackerFunction('clicked_delete_collection')
  const trackDeleteConfirm = useTrackerFunction('confirmed_delete_collection')

  const handleOpen = event => {
    trackMenuOpen()
    setToolBarOpen(event.currentTarget)
  }

  const handleClose = () => {
    setToolBarOpen(null)
  }

  const handleEdit = () => {
    trackDetailClick()
    history.push(`/collection/${collection.id}`)
    handleClose()
  }

  const deleteButtonClickHandler = e => {
    trackDeleteClick()
    handleClose()
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(ButtonType.NORMAL, 'No', ButtonActionType.NO, e => {
              dispatch(messageBoxHideAction())
            }),
            new ButtonData(
              ButtonType.ACTION,
              'Yes',
              ButtonActionType.DELETE,
              e => {
                trackDeleteConfirm()
                dispatch(
                  deleteCollection(collection.id, () => {
                    dispatch(messageBoxHideAction())
                  }),
                )
              },
            ),
          ],
          title: 'Delete Learning Path',
          subTitle: 'You are about to delete this learning path. Do you confirm?',
          description: null,
          note:
            'Note: Courses of this learning path will be deleted as well.',
          variant: MessageBoxVariant.NOTICE,
        }),
      ),
    )
  }

  return (
    <div
      className={classes.collectionToolBar}
      onClick={e => e.stopPropagation()}
    >
      {renderTrigger ? (
        renderTrigger({ openMenu: handleOpen })
      ) : (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0.5}
          width="100%"
        >
          <Typography
            className={classes.viewAllText}
            onClick={() => {
              trackViewAll()
              history.push(`/collection/${collection.id}/mini-courses`)
            }}
          >
            VIEW ALL
          </Typography>
          <CoreIconButton
            size="small"
            onClick={handleOpen}
            variant="text"
            color="secondary"
          >
            <Icon icon="eva:more-vertical-fill" width={20} height={20} />
          </CoreIconButton>
        </Stack>
      )}

      <MenuPopover
        open={Boolean(toolBarOpen)}
        anchorEl={toolBarOpen}
        onClose={handleClose}
        sx={{
          width: 'auto',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
        disabledArrow
      >
        <MenuItem onClick={handleEdit}>
          <Typography fontSize="14px" fontWeight={400}>
            Open
          </Typography>
        </MenuItem>
        <MenuItem onClick={deleteButtonClickHandler}>
          <Typography fontSize="14px" fontWeight={400}>
            Delete
          </Typography>
        </MenuItem>
      </MenuPopover>
    </div>
  )
}

export default withStyles(styles)(CollectionToolBar)
